module.exports = __webpack_public_path__ + "img/wix.fdb3c175.png";